/* Eznzza · botón "Agregar al carrito" fijo en mobile (ver eznzza-pdp-extras.css).
   Usa el botón principal del producto: copia su texto y precio, y al tocarlo
   hace click en él, así respeta la variante elegida, la pre-venta y el carrito. */
(function () {
  if (window.__ezMobileAtc) return;
  window.__ezMobileAtc = true;

  function init() {
    var main = document.querySelector('.main-product-section .atc-wrapper [data-add-to-cart-main]:not([data-sticky-atc-wrapper])');
    if (!main) return;

    var bar = document.createElement('div');
    bar.className = 'ez-matc';
    bar.innerHTML =
      '<button type="button" class="ez-matc-btn">' +
      '<span class="ez-matc-content"><span class="ez-matc-label"></span><span class="ez-matc-price"></span></span>' +
      '</button>';
    document.body.appendChild(bar);
    document.body.classList.add('ez-matc-on');

    var btn = bar.querySelector('.ez-matc-btn');
    var content = bar.querySelector('.ez-matc-content');
    var label = bar.querySelector('.ez-matc-label');
    var price = bar.querySelector('.ez-matc-price');

    function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

    function sync() {
      var l = txt(main.querySelector('.button-text')) || txt(main) || 'Agregar al carrito';
      var p = txt(main.querySelector('.product-price-main'));
      if (main.disabled || main.getAttribute('disabled') === 'true') {
        if (!/agotad|sin stock/i.test(l)) l = 'Sin stock';
      }
      label.textContent = l;
      price.textContent = p;
      price.style.display = p ? '' : 'none';
      content.setAttribute('data-up', p ? l + ' — ' + p : l);
      btn.disabled = main.disabled || main.getAttribute('disabled') === 'true';
      btn.setAttribute('aria-busy', main.classList.contains('loading') ? 'true' : 'false');
      btn.setAttribute('aria-label', content.getAttribute('data-up'));
    }
    sync();
    new MutationObserver(sync).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      main.click();
    });
    ['touchstart', 'mousedown'].forEach(function (ev) {
      btn.addEventListener(ev, function () { btn.classList.add('is-pressed'); }, { passive: true });
    });
    ['touchend', 'touchcancel', 'mouseleave'].forEach(function (ev) {
      btn.addEventListener(ev, function () { setTimeout(function () { btn.classList.remove('is-pressed'); }, 350); }, { passive: true });
    });

    /* Visible siempre, salvo cuando el botón principal ya está en pantalla */
    var shown = false;
    function show(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        show(!entries[0].isIntersecting);
      }, { threshold: 0.6 }).observe(main);
    } else {
      show(true);
    }
    requestAnimationFrame(function () {
      var r = main.getBoundingClientRect();
      show(!(r.top < window.innerHeight && r.bottom > 0));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
